<template lang="html">
  <div class="modal">
    <div class="keyboard-dialog-container"
    :class="{ 'loaded': loaded }">
      <div class="text-field-container d-flex align-items-center">
        <input ref="input" class="text-field" v-model="text" v-on:keyup.enter="$close(text)"/>
        <i class="fal fa-times"
        @click="text = ''"
        v-show="text"
        ></i>
      </div>
      <div class="keyboard-actions-container">
        <button
        class="btn btn-action"
        @click="$close(prevText)">close</button>
        <button
        class="btn btn-action"
        @click="$close(text)">submit</button>
      </div>
      <div class="keyboard">
        <div class="keyboard-row" v-for="(row, row_index) in keys" :key="row_index">
          <button type="button" name="button"
          class="btn-key" :id="key"
          :class="{'key': true, 'big': row_index === 0}"
          v-for="(key, index) in row"
          @click="keyClicked(key)"
          :key="key+index">
            <i class="fal fa-long-arrow-left"
              v-if="key === 'backspace'"
            ></i>
            <span v-else>{{ key }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'keyboard-input-dialog',
  data() {
    return {
      keys: [
        ['@gmail.com', '@outlook.com', '@live.com', '@yahoo.com'],
        ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'backspace'],
        ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', '@'],
        ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', '.'],
        ['z', 'x', 'c', 'v', 'b', 'n', 'm', '-', '_']
      ],
      text: '',
      loaded: false
    };
  },
  methods: {
    keyClicked(key) {
      console.log(key);
      switch (key) {
        case 'backspace':
          this.text = this.text.substr(0, this.text.length - 1);
          break;
        default:
          this.text += key;
      }
    },
  },
  created() {
    if (this.prevText) {
      this.text = this.prevText;
    } else {
      this.text = '';
    }
    this.loaded = false;
    setTimeout(() => {
      this.loaded = true;
      this.$refs.input.focus();
    }, 50, this);
  }
};
</script>

<style lang="scss" scoped>
.modal {
  font-family: Scandia-Regular, sans-serif;
  height: 100vh;
  background: transparent;
}

.keyboard-dialog-container {
  width: 100%;
  position: fixed;
  bottom: -500px;
  padding-bottom: 40px;
  background: hsla(0, 0, 90%, 0.9);

  &.loaded {
    transition: bottom 0.5s ease;
    bottom: 0;
  }
}

.text-field-container {
  position: relative;
  background: white;
  width: 800px;
  height: 60px;
  margin: 10px auto;
  border-radius: 6px;
  color: black;
  padding-left: 20px;
  padding-right: 20px;
  font-size: 2.4rem;

  .text-field {
    text-transform: uppercase;
    width: 100%;
    outline: none;
    border: none;

    &:focus {
      outline: none;
    }
  }

 .fa-times {
  position: absolute;
  right: 20px;
 }
}

.keyboard-actions-container {
  margin-bottom: 20px;

  .btn {
    text-transform: uppercase;
    padding: 10px 20px;
    margin: 0 2px;
    border-radius: 6px;
  }
}

/* Keyboard */
button#backspace {
  width: 100px;
}

.keyboard-row > .btn-key {
  display: inline-block;
  width: 55px;
  height: 55px;
  outline: none;
  color: white;
  background-color: hsl(0, 0, 20%);
  border: 2px solid black;
  border-radius: 6px;
  -moz-box-shadow:    inset 0 0 5px #000000;
  -webkit-box-shadow: inset 0 0 5px #000000;
  box-shadow:         inset 0 0 5px #000000;

  font-size: 21px;
  margin: 2px;
  text-align: center;
  text-transform: uppercase;
  font-size: 16px;
}

.keyboard-row:first-of-type > .btn-key {
  text-transform: lowercase;
}

.btn-key.big {
  width: 160px;
}

.btn-key:active {
  transform: scale(0.95);
  background-color: #000000;
  color: #ffffff;
}

.btn-key > .ion-ios-arrow-thin-left {
  font-size: 48px;
}


</style>



// WEBPACK FOOTER //
// src/components/Dialogs/KeyboardInputDialog.vue